import LoadingSpinner from "@/components/LoadingSpinner"
import AuthHeader from "@/features/auth/components/AuthHeader"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import AuthPageLayout from "@/features/platform-layout/components/AuthPageLayout"
import { useEffect } from "react"
import ForgotPasswordInsertCodeBox from "../components/ForgotPasswordInsertCodeBox"
import { useForgotPasswordInsertCode } from "../hooks/useForgotPasswordInsertCode"

const ForgotPasswordInsertCode = () => {

    const { onBackButtonClick, handleResendCode, handleInputSubmit, isLoading } = useForgotPasswordInsertCode()
    const { sendEvent } = useCreateEvent()

    useEffect(() => {
        void sendEvent({
            event: EventType.PAGE_VIEW,
            sub_category: "forgot_password_code_page",
        })
    }, [])

    // ********************************************************************************

    return (
        <AuthPageLayout>
            <AuthHeader
                onBackClick={onBackButtonClick}
            />
            <div className="w-full flex-1 flex flex-col items-center justify-center mt-[80px] overflow-hidden ">
                <div className="w-full sm:w-[328px] md:w-[400px] lg:w-[500px] p-[20px] bg-white">
                    <ForgotPasswordInsertCodeBox
                        onSubmit={handleInputSubmit}
                        onResendCodeClick={handleResendCode}
                    />
                </div>
            </div>
            {
                isLoading && <div className="w-full h-full div-center absolute"><LoadingSpinner /></div>
            }
        </AuthPageLayout>
    )
}

export default ForgotPasswordInsertCode
